<template>
    <div>
        <div class="border-t font-semibold mb-0 cursor-pointer relative text-primary py-3 pr-[30px] block"
             @click="show = !show"
             v-if="withTitle">
            {{ item.title }}
            <icon-arrow class="right-1 top-[50%] translate-y-[-50%]" :class="{'rotate-180': !show}"/>
        </div>

        <div v-show="show && withTitle">
            <item-child
                v-for="(child, index) in item.children"
                :key="`child-${child.id}-index-${index}`"
                :child="child"
            />
        </div>

        <div v-show="!withTitle">
            <item-child :child="item" :initial-show="show"/>
        </div>
    </div>
</template>

<script>
    import itemChild from "./item-child";

    export default {
        name: "item-group",
        components: {
            itemChild
        },
        props: {
            item: {
                type: Object,
                required: true
            },
            listingLength: {
                type: Number,
                default: 1
            },
            withTitle: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                show: false
            };
        },
        created () {
            if (this.listingLength === 1) {
                this.show = true;
            }
        }
    };
</script>
